import lo from 'lodash';

export function snakeCased(data) {
  if (Array.isArray(data)) return data.map(snakeCased);
  if (data === null) return data;
  if (typeof data !== 'object') return data;
  const snakeCasedData = {};
  lo.mapKeys(data, (value, key) => {
    snakeCasedData[lo.snakeCase(key)] = snakeCased(value);
  });
  return snakeCasedData;
}

export function toSnakeCase(data: any): any {
  if (Array.isArray(data)) {
    return data.map((item) => toSnakeCase(item));
  } else if (data !== null && typeof data === 'object') {
    return Object.entries(data).reduce((acc, [key, value]) => {
      const snakeKey = key.replace(
        /[A-Z]/g,
        (letter) => `_${letter.toLowerCase()}`
      );
      acc[snakeKey] = toSnakeCase(value);
      return acc;
    }, {} as Record<string, any>);
  }
  return data;
}
